import { Component } from '@angular/core';

import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'app-pen-icon',
  template: `<svg
    [attr.width]="width"
    [attr.height]="height"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.73036 15.0964C2.76865 14.7518 2.78779 14.5795 2.83992 14.4185C2.88617 14.2756 2.95152 14.1396 3.03419 14.0142C3.12737 13.8729 3.24995 13.7504 3.4951 13.5052L14.5003 2.49999C15.4208 1.57951 16.9132 1.57951 17.8337 2.49999C18.7542 3.42046 18.7542 4.91285 17.8337 5.83332L6.82843 16.8386C6.58328 17.0837 6.4607 17.2063 6.3194 17.2995C6.19403 17.3821 6.05807 17.4475 5.9152 17.4937C5.75416 17.5459 5.58187 17.565 5.2373 17.6033L2.41699 17.9167L2.73036 15.0964Z"
      [attr.stroke]="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg> `,
})
export class PenIcon extends BaseIconComponent {}
